import dayjs from "dayjs";
import "dayjs/locale/fi";
import "dayjs/locale/nb";
import "dayjs/locale/uk";
import "dayjs/locale/nl";
import "dayjs/locale/fr";

import utc from "dayjs/plugin/utc";
dayjs.extend(utc);

import duration from "dayjs/plugin/duration";
dayjs.extend(duration);

import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);

import isBetween from "dayjs/plugin/isBetween";
dayjs.extend(isBetween);

import customParseFormat from "dayjs/plugin/customParseFormat";
dayjs.extend(customParseFormat);

import { FipaDatePlugin } from "@/utils/formats";
dayjs.extend(FipaDatePlugin);

import relativeTime from "dayjs/plugin/relativeTime";
dayjs.extend(relativeTime);

import advancedFormat from "dayjs/plugin/advancedFormat";
dayjs.extend(advancedFormat);

import isoWeek from "dayjs/plugin/isoWeek";
dayjs.extend(isoWeek);

import updateLocale from "dayjs/plugin/updateLocale";
dayjs.extend(updateLocale);

dayjs.updateLocale("en", {
  ordinal: n => `${n}.`,
  weekStart: 1,
  yearStart: 4
});

export default dayjs;

export function setDayjsLocale(lng) {
  switch (lng) {
    case "nb-NO":
      dayjs.locale("nb"); // dayjs does not have nb-NO
      break;
    default:
      dayjs.locale(lng);
  }
}
